import { Typography } from "@mui/material";
import { SimType } from "../../../entity/Device";
import BaseStatusBox from "./BaseStatusBox";
import { DeviceUiConverter } from "../../../converter/DeviceUiConverter";

interface SimTypeBoxProps {
  type?: string;
  fontSize?: string;
  isBold?: boolean;
}

const SimTypeBox: React.FC<SimTypeBoxProps> = ({ 
  type, 
  fontSize, 
  isBold,
}) => {
  const simType: SimType = (type ?? "unknown") as SimType;

  return (
    (!!simType) ? (<BaseStatusBox
      isInvert={DeviceUiConverter.getSimTypeColorInvert(simType)}
      getStatusColorFn={(status, theme) => DeviceUiConverter.getSimTypeColor(status)}
      status={simType}
      statusStringKeyMap={DeviceUiConverter.SimTypeString}
      additionalBoxSx={(status, theme) => ({
        boxShadow: 0,
        padding: DeviceUiConverter.getSimTypePadding(status),
      })}
      additionalTypographySx={(status, theme) => ({
        fontSize: fontSize,
        fontWeight: isBold ? "bold" : "",
      })}
    />) : <Typography style={{ marginLeft: "22px" }}>-</Typography>
  );
}

export default SimTypeBox;